(() => {
  if (window.metCurrencyLanguageMounted) return;
  window.metCurrencyLanguageMounted = true;
  let box;
  let host;
  let frame;
  const initialized = new WeakSet();
  const isOpen = (trigger) => trigger.classList.contains('active') && !trigger.classList.contains('deactive');
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(place);
  };
  function enhance(root) {
    const trigger = root.querySelector('.buckscc-select-styled');
    const list = root.querySelector('.buckscc-select-options');
    if (!trigger || !list || initialized.has(trigger)) return;
    initialized.add(trigger);
    trigger.id = 'met-currency-language-trigger';
    trigger.tabIndex = 0;
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-controls', 'met-currency-language-options');
    list.id = 'met-currency-language-options';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-labelledby', trigger.id);
    const options = () => Array.from(list.querySelectorAll('li.converterTriggers')).filter((option) => option.getAttribute('rel') !== 'hide');
    const sync = () => {
      const open = isOpen(trigger);
      trigger.setAttribute('aria-expanded', String(open));
      list.setAttribute('aria-hidden', String(!open));
      const selected = trigger.querySelector('.bucks-selected')?.textContent.trim();
      options().forEach((option) => {
        option.setAttribute('role', 'option');
        option.tabIndex = -1;
        option.setAttribute('aria-selected', String(option.getAttribute('rel') === selected));
      });
    };
    new MutationObserver(sync).observe(trigger, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    root.addEventListener('keydown', (event) => {
      const items = options();
      const current = items.indexOf(document.activeElement);
      if (event.target !== trigger && current === -1) return;
      if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        event.stopPropagation();
        if (!isOpen(trigger)) trigger.click();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : event.key === 'ArrowDown' ? (current + 1) % items.length : (current <= 0 ? items.length - 1 : current - 1);
        items[index]?.focus();
      } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        event.stopPropagation();
        event.target.click();
        if (current !== -1) trigger.focus();
      } else if (event.key === 'Escape' && isOpen(trigger)) {
        event.preventDefault();
        event.stopPropagation();
        trigger.click();
        trigger.focus();
      } else if (event.key === 'Tab' && isOpen(trigger)) {
        trigger.click();
      }
      sync();
    });
    sync();
  }
  function place() {
    frame = null;
    const current = document.querySelector('.buckscc-floating-box');
    if (current) box = current;
    if (!box) return;
    const desktop = document.querySelector('#header-component .dropdown-localization:has(select[name="language_code"])');
    const drawer = document.querySelector('#header-component .menu-drawer__localization:has(select[name="language_code"])');
    const target = desktop?.getBoundingClientRect().width ? desktop : drawer;
    if (!target) {
      if (host) {
        host.classList.remove('met-currency-language');
        box.classList.remove('met-currency-language-widget');
        document.body.append(box);
        host = null;
      }
      return;
    }
    if (host && host !== target) host.classList.remove('met-currency-language');
    host = target;
    host.classList.add('met-currency-language');
    if (box.parentElement !== host) host.prepend(box);
    box.classList.add('met-currency-language-widget');
    enhance(box);
  }
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-menu-style'] });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();


// Font loading can change translated menu widths without resizing the header.
(() => {
  const reflow = () => requestAnimationFrame(() => {
    document.querySelectorAll('#header-component overflow-list').forEach(list => {
      list.dispatchEvent(new CustomEvent('reflow', { detail: {} }));
    });
  });
  if (document.fonts) {
    document.fonts.ready.then(reflow);
    document.fonts.addEventListener('loadingdone', reflow);
  }
  window.addEventListener('pageshow', reflow);
})();
